/* Maison Byōbu · premier écran d'achat de la fiche (sections/mb-oeuvre-achat.liquid, 07/10).
   La galerie (glisser au doigt, flèches, vignettes, points) et les murs types. Les murs types n'ont aucune valeur à eux :
   noms et dimensions sont lus sur les formats du cadreur (réglages de la section mb-cadreur), le prix est calculé par le
   cadreur lui-même (tarifImprime, marge de pose et remises grands murs comprises). Un clic choisit le format dans le cadreur. */
(() => {
  const d = document;
  const galerie = d.querySelector('[data-mb-galerie]');
  if (galerie) {
    const piste = galerie.querySelector('[data-mb-piste]');
    const vues = [...piste.children];
    const vignettes = galerie.querySelector('[data-mb-vignettes]');
    const points = [...galerie.querySelectorAll('.mb-achat__points i')];
    const numero = galerie.querySelector('[data-mb-numero]');
    vues.forEach((v, i) => {
      const img = v.querySelector('img');
      const b = d.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Voir l’image ${i + 1} : ${v.querySelector('figcaption')?.textContent || ''}`);
      b.setAttribute('aria-current', String(i === 0));
      b.innerHTML = `<img src="${img.currentSrc || img.src}" alt="" loading="lazy">`;
      b.addEventListener('click', () => aller(i));
      vignettes.appendChild(b);
    });
    const courant = () => Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
    const aller = (i) => piste.scrollTo({ left: i * piste.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    galerie.querySelector('[data-mb-precedent]')?.addEventListener('click', () => aller(Math.max(0, courant() - 1)));
    galerie.querySelector('[data-mb-suivant]')?.addEventListener('click', () => aller((courant() + 1) % vues.length));
    let attente = 0;
    piste.addEventListener('scroll', () => {
      cancelAnimationFrame(attente);
      attente = requestAnimationFrame(() => {
        const i = courant();
        if (numero) numero.textContent = i + 1;
        [...vignettes.children].forEach((b, k) => b.setAttribute('aria-current', String(k === i)));
        points.forEach((p, k) => p.toggleAttribute('data-actif', k === i));
      });
    }, { passive: true });
  }

  /* Murs types : quand le cadreur est prêt */
  const bloc = d.querySelector('[data-mb-formats]');
  const liste = d.querySelector('[data-mb-formats-liste]');
  if (!bloc || !liste || !('customElements' in window)) return;
  customElements.whenDefined('mb-cadreur').then(() => {
    const cadreur = d.querySelector('mb-cadreur');
    if (!cadreur || typeof cadreur.tarifImprime !== 'function') return;
    const formats = [...cadreur.querySelectorAll('[data-mb-format]')];
    const marge = 0; // MB_MARGE de mb-cadreur.js (0 depuis le 16/10 : plus de marge ajoutée) : « tout le mur », la marge touche chaque bord
    const metres = (cm) => (cm / 100).toLocaleString('fr-FR');
    let rendu = 0;
    formats.forEach((f, i) => {
      const l = parseFloat(f.dataset.l), h = parseFloat(f.dataset.h);
      if (!(l > 0 && h > 0)) return;
      const t = cadreur.tarifImprime(l + marge, h + marge);
      if (!t || !t.centimes) return;
      const nom = f.querySelector('.mb-format__nom')?.textContent.trim() || f.textContent.trim();
      const b = d.createElement('button');
      b.type = 'button';
      b.className = 'mb-achat__format';
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = `<span>${nom}<small>${metres(l)} × ${metres(h)} m</small></span><span class="mb-achat__format-prix">${t.barre ? `<s>${t.barre}</s>` : ''}${t.prix}</span>`;
      b.addEventListener('click', () => {
        liste.querySelectorAll('.mb-achat__format').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        f.click();
        d.getElementById('cadrer')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.mbMesure) window.mbMesure('fiche-format', { format: nom });
      });
      liste.appendChild(b);
      rendu += 1;
    });
    if (rendu) bloc.hidden = false;
  });
})();
